import { createFileRoute } from '@tanstack/react-router';

import { client } from '@@api/client';
import { handleLoaderError } from '@@router/handleLoaderError';

import NewsletterForm from './-components/NewsletterForm';

export const Route = createFileRoute('/_authenticated/newsletters/$id')({
    context: ({ params }) => ({
        newsletterQuery: client.newsletter.newsletter.get.queryOptions(
            { params: { id: params.id } },
            { refetchOnWindowFocus: false },
        ),
    }),
    loader: ({ context }) =>
        context.queryClient
            .query({ ...context.newsletterQuery, staleTime: 'static' })
            .catch(handleLoaderError),
    component: NewsletterForm,
});
